import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useBoard } from "../../models/board";
import { useInvites } from "../../models/invite";
import { useUser } from "../../models/user";
import { AppDispatch } from "../../redux/store";
import { showToast } from "./toastSlice";
import { toast } from "./toastTypes";

export function InviteToastWatcher({ userUid }: { userUid: string }) {
  const [user] = useUser(userUid);
  const boardUids = user?.boardUids ? Array.from(user.boardUids.keys()) : [];

  return (
    <>
      {boardUids.map(uid => (
        <InviteBoardWatcher key={uid} boardUid={uid} userUid={userUid} />
      ))}
    </>
  );
}

function InviteBoardWatcher({ boardUid, userUid }: { boardUid: string; userUid: string }) {
  const dispatch = useDispatch<AppDispatch>();
  const [board] = useBoard(boardUid);
  const [invites] = useInvites(boardUid);

  useEffect(() => {
    if (board && board.ownerUid === userUid && invites && invites.length > 0) {
      dispatch(showToast(toast("boardInvites", {
        boardUid,
        ownerUid: board.ownerUid,
        boardTitle: board.title,
        inviteCount: invites.length,
      }, boardUid)));
    }
  }, [board, invites, boardUid, userUid, dispatch]);

  return null;
}
